import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";

import FacebookIcon from "../../../src/assets/images/facebook.png";
import { FontVariant } from "../../constants/fonts";

const Container = styled.div`
  height: 836px;
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 20px 0px 20px;
`;

const CircleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const LoginText = styled.h2`
  text-align: start;
  font-weight: bold;
  margin-bottom: 20px;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  padding: 0px 10px;
  width: 100%;
`;

const TextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const Label = styled.p`
  text-align: start;
  font-size: 12px;
`;

const TextValue = styled.p`
  width: 100%;
  border-bottom: 1px solid;
  text-align: start;
  font-size: 16px;
`;

const ErrorText = styled.p`
  font-size: 16px;
`;

const LoginButton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const SocialAuthButton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
`;

const FacebookLogo = styled.img`
  height: 30px;
  margin-right: 10px;
`;

const CheckboxSection = styled.div`
  margin-top: 20px;
  margin-bottom: 0px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
`;

const Checkbox = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 5px;
  border: 1px solid;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const UserName = styled.div`
  font-family: poppins-semibold;
  font-size: 30px;
  font-weight: bold;
`;

const NavLink = styled.div`
  font-family: poppins;
  font-size: 30px;
  margin-top: 20px;
`;

export default function SecondaryThemePreview() {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { secondary } = values;
  const { color, content, buttons, highlights } = secondary;
  const { default: defaultHighLight } = highlights;
  const { default: defaultButton, alt_1: alt1Button } = buttons;
  const {
    default: defaultContentColor,
    danger: dangerContentColor,
    alt_1: alt1ContentColor,
  } = content;

  return (
    <Container
      style={{
        backgroundColor: color,
      }}
    >
      <CircleButton
        style={{
          backgroundColor: defaultButton.color,
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          size="xs"
          color={defaultButton.content}
        />
      </CircleButton>
      <ContentContainer>
        <LoginText
          style={{
            fontFamily: FontVariant.PrimaryBold,
            color: defaultContentColor,
          }}
        >
          Login
        </LoginText>

        <TextInputContainer>
          <Label
            style={{
              color: defaultContentColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Email Address
          </Label>
          <TextValue
            style={{
              fontFamily: FontVariant.PrimaryRegular,
              color: defaultContentColor,
              borderBottomColor: defaultContentColor,
            }}
          >
            mockup.orderapp@ancon.io
          </TextValue>
        </TextInputContainer>
        <TextInputContainer>
          <Label
            style={{
              color: defaultContentColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Password
          </Label>
          <TextValue
            style={{
              fontFamily: FontVariant.PrimaryRegular,
              color: defaultContentColor,
              borderBottomColor: defaultContentColor,
            }}
          >
            *********
          </TextValue>
          <ErrorText
            style={{
              color: dangerContentColor,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Error Message
          </ErrorText>
        </TextInputContainer>

        <CheckboxSection
          style={{
            borderColor: defaultContentColor,
            color: defaultContentColor,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          <Checkbox />I agree to the terms of this service
        </CheckboxSection>
        <CheckboxSection
          style={{
            color: defaultContentColor,
            marginBottom: 20,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          <Checkbox
            style={{
              borderColor: defaultHighLight,
              backgroundColor: defaultHighLight,
            }}
          >
            <FontAwesomeIcon
              size="xs"
              icon={faCheck}
              color={defaultButton.content}
            />
          </Checkbox>
          I agree to the terms of this service
        </CheckboxSection>

        <LoginButton
          style={{
            backgroundColor: defaultButton.color,
            color: defaultButton.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Log In
        </LoginButton>

        <SocialAuthButton
          style={{
            backgroundColor: alt1Button.color,
            color: alt1Button.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          <FacebookLogo src={FacebookIcon} /> Login With Facebook
        </SocialAuthButton>

        <hr
          style={{
            height: 2,
            color: defaultContentColor,
          }}
        />
        <UserName
          style={{
            color: defaultContentColor,
            fontFamily: FontVariant.PrimaryBold,
          }}
        >
          Hey James
        </UserName>
        <NavLink
          style={{
            color: alt1ContentColor,
            fontFamily: FontVariant.PrimaryBold,
          }}
        >
          Account Details
        </NavLink>
        <NavLink
          style={{
            color: alt1ContentColor,
            fontFamily: FontVariant.PrimaryBold,
          }}
        >
          My Orders
        </NavLink>
      </ContentContainer>
    </Container>
  );
}
